export default [
  {
    path: '/summary/:key?',
    name: 'summaryPage',
    component: () => import(/*webpackChunkName:'summary'*/ '@/views/summary/index.vue'),
    meta: {},
  },
];
